
import { Coordinate } from '../map-event.objects';

const Cesium = (<any>window).Cesium

/**
 * an implmentation speicifc coordinate. Contains untis to convert from cesium to standard coords
 * as well as placeholders for holding the cesium cartesian coords so they dont need to be recalced
 */
export class CesiumCoordinate implements Coordinate{
  latitude:number
  longitude:number
  height:number

  get screenPosition(){
    if(this._screenPos == null)
      throw Error("TODO Cannot derive without the scene object so cannot htin of nice interface")
    //  this._screenPos = Cesium.SceneTransforms.wgs84ToDrawingBufferCoordinates(this.scene, this.cartesian)

    return this._screenPos
  }
  private _screenPos:{
    x:number
    y:number
  } = null
  
  // efficiencies for holding the cartiesian so we dont have to convert every mouse click
  private _cartesian:any
  get cartesian(){
    if(!this._cartesian) 
      this._cartesian = Cesium.Cartesian3.fromCartographic(this)
    return this._cartesian
  }

  constructor(cesiumCoord:any,screenCoord?:any){
    if(cesiumCoord && cesiumCoord.x)
      CesiumCoordinate.catersianToCoord(cesiumCoord,screenCoord,this)

      this._screenPos = screenCoord
  }

  static catersianToCoord(cartesian:any,screenCoord:any,ref?:CesiumCoordinate):CesiumCoordinate{
    ref = ref || new CesiumCoordinate(null,screenCoord)

    if(screenCoord)
      ref._screenPos = screenCoord

    var cartographic = Cesium.Cartographic.fromCartesian(cartesian);
   
    ref.latitude = cartographic.latitude
    ref.longitude = cartographic.longitude
    ref.height = cartographic.height
    ref._cartesian = cartesian

    return ref
  }
  setScreen(scene){
    this._screenPos = scene.cartesianToCanvasCoordinates(this.cartesian)
  }
}
